import { Col, Container, Row } from "react-bootstrap";
import Carousel from 'react-bootstrap/Carousel';
import carrouselHistoria1 from '../../assets/history/carrouselHistoria1.jpg';
import carrouselHistoria2 from '../../assets/history/carrouselHistoria2.jpg';
import carrouselHistoria3 from '../../assets/history/carrouselHistoria3.jpg';
import carrouselHistoria4 from '../../assets/history/carrouselHistoria4.png';
import gifFabrica1 from '../../assets/history/Fabrica1.gif'
import gifFabrica2 from '../../assets/history/Fabrica2.gif'
import gifFabrica3 from '../../assets/history/Fabrica3.gif'
import Navbar from '../../components/Navbar/Navbar'
import Footer from '../../components/Footer/Footer';
import { useTranslation } from 'react-i18next'

const container = {
    marginTop: '30px',
    marginBottom: '30px'
  }

function OurHistoryPage() {

    const { i18n, t } = useTranslation();

    return (

        <Container>
            <Row>
                <Col md={12}>
                    <h1>{t('historyTitle')}</h1>
                </Col>
                <Col md={6}>
                <Carousel fade>
                    <Carousel.Item>
                        <img
                        src={carrouselHistoria1}
                        width="100%"
                        height="100%"
                        className="d-inline-block align-top"
                        alt="Pais"
                        />
                    </Carousel.Item>
                    <Carousel.Item>
                    <img
                        src={carrouselHistoria2}
                        width="100%"
                        height="100%"
                        className="d-inline-block align-top"
                        alt="Peregrino"
                        />
                    </Carousel.Item>
                            <Carousel.Item>
                    <img
                        src={carrouselHistoria3}
                        width="100%"
                        height="100%"
                        className="d-inline-block align-top"
                        alt="Peregrino"
                        />
                    </Carousel.Item>
                    <Carousel.Item>
                    <img
                        src={carrouselHistoria4}
                        width="100%"
                        height="100%"
                        className="d-inline-block align-top"
                        alt="Aba logo"
                        />
                    </Carousel.Item>
                </Carousel>
                </Col>
                <Col md={6} style={{ textAlign: 'justify'}}>
                    <p>{t('histoyText1')}</p>
                    <p> {t('historyText2')}
                    </p>
                </Col>
                <hr/>
                {/* <Col>
                    <h2>Mision</h2>
                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Quisque bibendum sem nec magna aliquet ultrices. 
                    Vestibulum vel arcu ut ipsum ornare scelerisque eu at dolor. Sed in tempor est. Etiam non risus vel nunc pulvinar blandit. 
                    Sed volutpat metus vel risus lacinia posuere. Nulla sit amet volutpat diam. Curabitur eleifend justo ac lobortis pretium. 
                    Vivamus neque tortor, egestas vel egestas et, sollicitudin ac ex.</p>
                </Col>
                <Col md={6}>
                    <img
                        src={carrouselPais}
                        width="100%"
                        height="100%"
                        className="d-inline-block align-top"
                        alt="Pais"
                    />
                </Col>
                <hr/>
                <Col md={6}>
                    <img
                        src={carrouselPais}
                        width="100%"
                        height="100%"
                        className="d-inline-block align-top"
                        alt="Pais"
                    />
                </Col>
                <Col>
                    <h2>Vision</h2>
                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Quisque bibendum sem nec magna aliquet ultrices. 
                    Vestibulum vel arcu ut ipsum ornare scelerisque eu at dolor. Sed in tempor est. Etiam non risus vel nunc pulvinar blandit. 
                    Sed volutpat metus vel risus lacinia posuere. Nulla sit amet volutpat diam. Curabitur eleifend justo ac lobortis pretium. 
                    Vivamus neque tortor, egestas vel egestas et, sollicitudin ac ex.</p>
                </Col> */}
                <Col md={12}>
                    <h2>{t('factory')}</h2>
                    <p>{t('historyText3')}</p>
                </Col>
                <Col md={4} style={container}>
                    <img
                        src={gifFabrica1}
                        width="100%"
                        height="100%"
                        className="d-inline-block align-top"
                        alt="Pais"
                    />
                </Col>
                <Col md={4} style={container}>
                    <img
                        src={gifFabrica2}
                        width="100%"
                        height="100%"
                        className="d-inline-block align-top"
                        alt="Pais"
                    />
                </Col>
                <Col md={4} style={container}>
                    <img
                        src={gifFabrica3}
                        width="100%"
                        height="100%"
                        className="d-inline-block align-top"
                        alt="Pais"
                    />
                </Col>
            </Row>
        </Container>
    ); 
}

export default OurHistoryPage;